import * as React from "react";

export const MailIcon = (props: any) => (
  <svg
    width={56}
    height={56}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x={4} y={4} width={48} height={48} rx={24} fill="#D1FADF" />
    <path
      d="M19 19h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H19a1 1 0 0 1-1-1V20a1 1 0 0 1 1-1Zm17 4.238-7.928 7.1L20 23.216V35h16V23.238ZM20.511 21l7.55 6.662L35.502 21H20.511Z"
      fill="#333"
    />
    <rect
      x={4}
      y={4}
      width={48}
      height={48}
      rx={24}
      stroke="#ECFDF3"
      strokeWidth={8}
    />
  </svg>
);
